const activeMobileClass = 'header-mobile-nav-active';
const headerMenuToggleClass = '.header__menu-toggle';
const headerMenuActiveClass = 'header__menu-toggle--is-active';
const headerMenuToggle = document.querySelector(headerMenuToggleClass);
const headerMenuItems = document.querySelectorAll('.header__mobile-nav-menu .menu-item');

/**
 * Close the menu by removing active classes
 */
function closeMenu() {
    document.body.classList.remove(activeMobileClass);
    if (headerMenuToggle) {
        headerMenuToggle.classList.remove(headerMenuActiveClass);
    }
}

/**
 * Check and remove active mobile menu class on window resize
 * When window is larger than 1366
 */
function checkAndRemoveActiveMobileClass() {
    if (window.innerWidth >= 1366 && document.body.classList.contains(activeMobileClass)) {
        closeMenu();
    }
}

/**
 * Toggle the menu
 */
function toggleMenu() {
    function menuClickHandler() {
        headerMenuToggle.classList.toggle(headerMenuActiveClass);
        document.body.classList.toggle(activeMobileClass);
        checkAndRemoveActiveMobileClass();
    }

    if (headerMenuToggle) {
        headerMenuToggle.addEventListener('click', menuClickHandler);
    }

    // Add event listener for window resize
    window.addEventListener('resize', checkAndRemoveActiveMobileClass);
}

/**
 * Close the menu on menu item click
 */
if (headerMenuItems.length > 0) {
    headerMenuItems.forEach(function(item) {
        item.addEventListener('click', function(event) {
            closeMenu();
        });
    });
}

/**
 * Close the menu on esc key
 */
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        closeMenu();
    }
});

// Toggle main nav
toggleMenu();
